import React from 'react';
import { Box, Checkbox, FormControlLabel } from '@mui/material';
import { COLOR } from '@src/styles/color';
import { useTranslation } from 'react-i18next';
import InfoIcon from '@mui/icons-material/Info';
import sanitizeHtml from 'sanitize-html';
import Typography from '@src/new-components/Typography';
import { StyledWithDrawalFooter } from './index.style';

const WithDrawalFooter = ({ isAcceptPolicy, handleAcceptPolicy, disabled }) => {
  const { t } = useTranslation();
  return (
    <StyledWithDrawalFooter>
      <Box className="tax-info-container">
        <InfoIcon className="tax-info-icon" />
        <Typography
          variant="body-14-regular"
          color={COLOR.descriptionGray}
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(t('taxInfoDescription', { taxPercent: 10 }), {
              allowedTags: ['a', 'br'],
              allowedAttributes: {
                a: ['href', 'target', 'rel', 'style'],
              },
            }),
          }}
        />
      </Box>
      {!disabled && (
        <FormControlLabel
          className="confirm-request-withdrawal-checkbox-container"
          sx={{
            textAlign: 'left',
            alignItems: 'flex-start',
            marginRight: '0px',
          }}
          control={
            <Checkbox
              className="confirm-request-withdrawal-checkbox"
              sx={{
                '&.Mui-checked': {
                  color: COLOR.indigo.default,
                },
                '&.MuiCheckbox-root': {
                  padding: '0px',
                },
              }}
              checked={isAcceptPolicy}
              onChange={handleAcceptPolicy}
            />
          }
          label={
            <Typography
              variant="body-14-regular"
              component="span"
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(t('confirmRequestWithdrawal'), {
                  allowedTags: ['a'],
                  allowedAttributes: {
                    a: ['href', 'target', 'rel', 'style'],
                  },
                }),
              }}
            />
          }
        />
      )}
    </StyledWithDrawalFooter>
  );
};

export default WithDrawalFooter;
